export default "__VITE_ASSET__CFyzHDy0__"